import React, { useEffect } from 'react';
import ErrorBoundary from '@/components/ErrorBoundary';
import PoweredBy from '@/components/PoweredBy';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  useEffect(() => {
    document.body.style.setProperty(
      'background-color',
      'var(--color-login-bg, var(--color-primary))',
    );
    return () => {
      document.body.style.removeProperty('background-color');
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center pb-8">
      <ErrorBoundary>
        {children}
        <PoweredBy />
      </ErrorBoundary>
    </div>
  );
};

export default AuthLayout;
